import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-special-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Project Name", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "productNameError"
}, null, -1)
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Select Type ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "-- Special Project Type --", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "projectTypeError"
}, null, -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "d-flex mb-15 justify-content-between" }
const _hoisted_16 = {
  key: 0,
  class: "card-title fw-bold"
}
const _hoisted_17 = { class: "d-flex justify-content-end" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Name ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "contactNameError"
}, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Phone", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "contactPhoneError"
}, null, -1)
const _hoisted_26 = {
  key: 2,
  class: "col-md-4"
}
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Email", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "contactEmailError"
}, null, -1)
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "d-flex mb-15 justify-content-between" }
const _hoisted_32 = {
  key: 0,
  class: "card-title fw-bold"
}
const _hoisted_33 = { class: "d-flex justify-content-end" }
const _hoisted_34 = {
  key: 0,
  class: "list-group mb-15"
}
const _hoisted_35 = { class: "d-flex flex-column" }
const _hoisted_36 = { class: "mb-1 fs-md-15 fs-lg-16" }
const _hoisted_37 = { class: "dropdown" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition fs-20 no-after text-paragraph",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1)
const _hoisted_39 = { class: "dropdown-menu" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_44 = { class: "col-md-12" }
const _hoisted_45 = {
  key: 0,
  class: "d-flex mb-15"
}
const _hoisted_46 = {
  key: 1,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " File Url ", -1)
const _hoisted_48 = { class: "input-group" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-close position-relative top-1" }, null, -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "projectFileUrlError"
}, null, -1)
const _hoisted_52 = { class: "col-md-12" }
const _hoisted_53 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Notes / Instructions", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "projectNotesError"
}, null, -1)
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}
const _hoisted_58 = {
  class: "modal fade",
  id: "addComponentModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_59 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_60 = { class: "modal-content" }
const _hoisted_61 = { class: "modal-header" }
const _hoisted_62 = { class: "modal-title fs-5" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_64 = { class: "modal-body" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-md-2" }
const _hoisted_67 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Quantity", -1)
const _hoisted_69 = { class: "col-md-10" }
const _hoisted_70 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Product", -1)
const _hoisted_72 = { class: "modal-footer" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_model_select = _resolveComponent("model-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCreateOrUpdateSpecialProject && _ctx.submitCreateOrUpdateSpecialProject(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "productName",
                  class: "form-control shadow-none rounded-0 text-black",
                  placeholder: "e.g. Resticker Lot Number",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projectName) = $event)),
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateProjectName && _ctx.validateProjectName(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.projectName]
                ]),
                _hoisted_7
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select shadow-none fw-semibold rounded-0",
                  name: "projectType",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.projectType) = $event)),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateProjectType && _ctx.validateProjectType(...args))),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validateProjectType && _ctx.validateProjectType(...args)))
                }, [
                  _hoisted_11,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectTypes, (typeObj) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: typeObj.type,
                      key: typeObj.type
                    }, _toDisplayString(typeObj.name), 9, _hoisted_12))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.projectType]
                ]),
                _hoisted_13
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_ctx.addContactPerson)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_16, " Contact Person "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  (!_ctx.addContactPerson)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-outline-primary btn-sm position-relative",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addContactPersonClicked()))
                      }, "Add Contact Person"))
                    : _createCommentVNode("", true),
                  (_ctx.addContactPerson)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-outline-danger btn-sm position-relative",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeContactPersonClicked()))
                      }, "Remove"))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.addContactPerson)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "contactName",
                        class: "form-control shadow-none rounded-0 text-black",
                        placeholder: "e.g. Joe Smith",
                        minlength: "3",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contactName) = $event)),
                        onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateContactName && _ctx.validateContactName(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.contactName]
                      ]),
                      _hoisted_21
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.addContactPerson)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        name: "contactPhone",
                        class: "form-control shadow-none rounded-0 text-black",
                        placeholder: "e.g. (999) 999-9999",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contactPhone) = $event)),
                        onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.validatePhone && _ctx.validatePhone(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.contactPhone]
                      ]),
                      _hoisted_25
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.addContactPerson)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        name: "contactEmail",
                        class: "form-control shadow-none rounded-0 text-black",
                        placeholder: "e.g. name@merchant.com",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contactEmail) = $event)),
                        onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.contactEmail]
                      ]),
                      _hoisted_29
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                (_ctx.stockProducts.length)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_32, " Products "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary btn-sm position-relative",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#addComponentModal",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addStockProductClicked()))
                  }, "Add Products")
                ])
              ]),
              (_ctx.stockProducts.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockProducts, (stockProduct) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "list-group-item fw-medium fs-md-15 d-flex justify-content-between",
                        key: stockProduct.id
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("p", _hoisted_36, _toDisplayString(stockProduct.quantity) + " x " + _toDisplayString(stockProduct.name), 1),
                          _createElementVNode("small", null, "UPC: " + _toDisplayString(stockProduct.upc), 1)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("ul", _hoisted_39, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#addComponentModal",
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.editStockProduct(stockProduct.id))
                              }, [
                                _hoisted_41,
                                _createTextVNode(" Edit ")
                              ], 8, _hoisted_40)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center cursor-pointer",
                                onClick: ($event: any) => (_ctx.deleteStockProduct(stockProduct.id))
                              }, [
                                _hoisted_43,
                                _createTextVNode(" Delete")
                              ], 8, _hoisted_42)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_44, [
              (!_ctx.addProjectFileUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-primary btn-sm position-relative ml-1",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addFileUrlClicked()))
                    }, "Add File Url")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.addProjectFileUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        type: "url",
                        name: "projectFileUrl",
                        class: "form-control shadow-none rounded-0 text-black",
                        placeholder: "e.g. www.example.com/file-name",
                        minlength: "5",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.projectFileUrl) = $event)),
                        onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.validateProjectFileUrl && _ctx.validateProjectFileUrl(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.projectFileUrl]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-danger position-relative transition border-0 fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.removeFileUrlClicked()))
                      }, _hoisted_50),
                      _hoisted_51
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  name: "projectNotes",
                  rows: "5",
                  class: "form-control shadow-none rounded-0 text-black",
                  minlength: "10",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.projectNotes) = $event)),
                  onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.validateProjectNotes && _ctx.validateProjectNotes(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.projectNotes]
                ]),
                _hoisted_55
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", _hoisted_57, _toDisplayString(_ctx.specialProject ? 'Update' : 'Create') + " Special Project ", 1)
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("h1", _hoisted_62, _toDisplayString(_ctx.updateStockProductId ? 'Edit' : 'Add') + " Product", 1),
            _hoisted_63
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "1",
                    class: "form-control shadow-none rounded-0 text-black",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newStockProductQty) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newStockProductQty]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createVNode(_component_model_select, {
                    class: "form-control shadow-none rounded-0 text-black",
                    placeholder: "e.g. Black Wristband",
                    name: "newStockProductId",
                    modelValue: _ctx.newStockProductId,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newStockProductId) = $event)),
                    options: _ctx.newStockProductOptions,
                    onSearchchange: _ctx.updateProductSearch
                  }, null, 8, ["modelValue", "options", "onSearchchange"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addOrUpdateStockProduct && _ctx.addOrUpdateStockProduct(...args))),
              class: "btn btn-outline-primary"
            }, _toDisplayString(_ctx.updateStockProductId ? 'Update' : 'Add'), 1)
          ])
        ])
      ])
    ])
  ], 64))
}